import React from "react";
import Inputs from "./Components/Inputs";

const Quiz_home = () => {
  return (
    <section className="q-wrapper">
      <div>
        <Inputs />
      </div>
    </section>
  );
};

export default Quiz_home;
